/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentCycle from './treatment-cycle';
import TreatmentCycleDetail from './treatment-cycle-detail';
import TreatmentCycleUpdate from './treatment-cycle-update';
import TreatmentCycleDeleteDialog from './treatment-cycle-delete-dialog';

const TreatmentCycleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentCycle />} />
    <Route path="new" element={<TreatmentCycleUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentCycleDetail />} />
      <Route path="edit" element={<TreatmentCycleUpdate />} />
      <Route path="delete" element={<TreatmentCycleDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentCycleRoutes;
